import { BigDecimal, LogisticaTiposEntrega, TiposIdentificacion } from "@pcgerente-node/pcg-comun";
import { CLIENTE, CLIENTE_DIRECCION_PROFORMA, USUARIO_CLIENTE, logistica_CONTENIDO, logistica_GUIA_PROFORMA, logistica_RANGO_GUIA, logistica_RANGO_SEGURO } from "@pcgerente-node/pcg-comun/dist/DTOs";
import { BaseViewModelClass } from "../Utils/BaseViewModel";
import { esEmailValido, numerosNaturales } from "../Utils/regex";
import { logistica_GUIA_PROFORMALocal } from "../components/Entidades/logistica_GUIA_PROFORMA";
import { clearProductosDisponibles, getProductosDisponibles } from "../redux/actions/actionsCrear";
import { RowContenidoviewModel } from "./RowContenidoviewModel";

export class logistica_GUIA_PROFORMAviewModel extends BaseViewModelClass<logistica_GUIA_PROFORMA> {
    constructor(){
        super(new logistica_GUIA_PROFORMA())
    }
    public guia: logistica_GUIA_PROFORMA = new logistica_GUIA_PROFORMA
    //Contenido Mostrado en la UI
    public rowsContenidoParaCrear: RowContenidoviewModel[] = []; 
    //Contenido Disponible para el cliente
    public contenidoList: logistica_CONTENIDO[] = []; 
    public CrearCliente:boolean = false 
   
    estadoInicial(setState: (props:logistica_GUIA_PROFORMALocal) => void){
        setState(new logistica_GUIA_PROFORMALocal())
    }

    private _requiereRecargarContenido = false
    public RequiereRecargarContenido(){
        return this._requiereRecargarContenido
    }
    limpiarContenidoParaCrear(requiereRecargarContenido: boolean){
        this.rowsContenidoParaCrear = []
        while (this.rowsContenidoParaCrear.length<=5){
            this.rowsContenidoParaCrear.push(new RowContenidoviewModel())
        }
        this._requiereRecargarContenido = requiereRecargarContenido
    }
    ObtenerContenido(dispatch: (details: any) => void){
        dispatch(clearProductosDisponibles())
        this._requiereRecargarContenido = false
    }


    hayContenidoConCantidadBultosEn0(guia : logistica_GUIA_PROFORMALocal){
      let retorno = false
      for (let det of guia.rowsContenidoParaCrear) {
        if (det.precio.toNumber() !== 0){
          if(det.seguro === false){
            if(det.cantidad.toNumber() === 0 || det.bultos === 0) {
              retorno = true
            }
          }
        }
      }
      return retorno
    }
    Validar(guia: logistica_GUIA_PROFORMALocal){
      let retorno = ""
      if (!guia.CLIENTE_DESTINATARIO?.cedula || !guia.CLIENTE_DESTINATARIO?.razonSocial) {
          retorno = "No se han llenado los datos del destinatario, por favor introduzca una cédula/RUC para hacer el autocompletado"
      }else if (guia.rowsContenidoParaCrear  ?.length === 0) {//
          retorno = "No se han llenado los datos del contenido a esta guia"
      }else if (!(guia.idCiudadDestino || guia.CLIENTE_DESTINATARIO.ciudad) || !guia.idCiudadOrigen || (guia.tipoEntrega !== LogisticaTiposEntrega.Domicilio && guia.tipoEntrega !== LogisticaTiposEntrega.RetiroOficina)) {
          retorno = "No se han completado los detalles de envio. Verifica que los campos: 'Origen','Destino' y 'Tipo de Entrega' estén completos"
      }else if (guia.CLIENTE_REMITENTE?.id === 0 && this.ValidacionesDestinatario(guia).length) {
          retorno = this.ValidacionesDestinatario(guia)
      }else if (this.hayContenidoConCantidadBultosEn0(guia)) {
          retorno = "No se puede asignar una cantidad o bultos igual a 0 en el contenido"
      }else if (!guia.CLIENTE_REMITENTE?.razonSocial || !guia.CLIENTE_REMITENTE?.cedula || !guia.CLIENTE_REMITENTE?.telefono || !guia.CLIENTE_REMITENTE?.direccion) {
          retorno = "No se han llenado los datos del remmitente, por favor introduzca una cédula/RUC para hacer el autocompletado"
      }else if (guia.rowsContenidoParaCrear.length > 0) {
          let noHayContenido = true
          for (let det of guia.rowsContenidoParaCrear) {
              if (det.descripcion) {
                noHayContenido = false
              }
          }
          if (noHayContenido) {
              retorno = "No ha seleccionado ningún contenido aún"
          }
      }else if (this.CrearCliente && (guia.CLIENTE_DESTINATARIO.cedula.length !== 10 && guia.CLIENTE_DESTINATARIO.cedula.length !== 13)) {
      retorno = "La identificación del nuevo Cliente no es de Tipo RUC o cédula"
      }else {
        guia.rowsContenidoParaCrear?.forEach((det, i) => {
          if (det.descripcion && det.descripcion.length > 0 && new BigDecimal(det.cantidad).toNumber() === 0) {
          retorno = `El contendido en la fila #${i + 1}: ${det.descripcion} no puede tener una cantidad igual a 0`
          }
        });
      }
      if(! this.validarDocumentosRelacionados(guia.documentosRelacionados)){
          retorno = 'El formato de los documentos relacionados no es válido, si ingresa varios deben estar separados por comas de esta forma: 999-999-999,999-999-998)';
      }
      if(retorno)
        throw new Error(retorno)
    }
    ValidacionesDestinatario(guia: logistica_GUIA_PROFORMALocal) {
      let mensajeError = ""
      const nuevoCLiente = guia.CLIENTE_DESTINATARIO
      if (nuevoCLiente) {
        if (nuevoCLiente.cedula.length < 10) {
          mensajeError = "La cédula del destinatario no puede tener menos de 10 dígitos"
        }else if (nuevoCLiente.telefono.length < 6) {
          mensajeError = "El número de telefono del destinatario no es válido"
        }else if (nuevoCLiente.direccion.length < 18) {
          mensajeError = "La dirección del destinatario es muy corta"
        }else if (nuevoCLiente.email && !esEmailValido(nuevoCLiente.email)) {
          mensajeError = "la dirección de corrreo electrónica no es válido"
        }else if (nuevoCLiente.razonSocial && nuevoCLiente.razonSocial.length < 12) {
          mensajeError = "la Razón Social del destinatario es muy corta"
        }
      }else {
        mensajeError = "no se encontro el nuevo cliente para crear"
      }
      return mensajeError
    }
    //Mira si esto es necesario
    



      obtenerTipoIdentificacion(cedula: string){
        let retorno: TiposIdentificacion
        if(cedula.endsWith("001") && cedula.length === 13){
            retorno = TiposIdentificacion.RUC
        }else if(cedula.length === 10){
            retorno = TiposIdentificacion.RUC
        }else{
            retorno = TiposIdentificacion.Pasaporte
        }
        return retorno 
      }

      cargarDatos(guia: logistica_GUIA_PROFORMALocal, setState: (props:logistica_GUIA_PROFORMALocal) => void){
        setState(guia)
      }

      EstablecerRango(rango: logistica_RANGO_GUIA,  guia: logistica_GUIA_PROFORMALocal, setState: (props:logistica_GUIA_PROFORMALocal) => void){
          setState({
            ...guia,
            numeroDocumento: rango.numero,
            serie1: rango.serie1,
            serie2: rango.serie2
          })
      }

      CrearDestinatario(setCrearDestinatario: (details: boolean) => void, isChecked: boolean, guia: logistica_GUIA_PROFORMALocal, setState: (props:logistica_GUIA_PROFORMALocal) => void){
        setState({
          ...guia,
          CLIENTE_DESTINATARIO: new CLIENTE(),
          idDestinatario: 0,
          idClienteDireccionProforma: undefined
        })
        setCrearDestinatario(isChecked)
      }

      EstablecerClienteRemitente(clientes: USUARIO_CLIENTE[], idCliente: number,  guia: logistica_GUIA_PROFORMALocal, setState: (props:logistica_GUIA_PROFORMALocal) => void,idCiudadOrigenPredeterminada?: number){
        if(clientes.length>0){ 
          const recuperado = clientes.find(r => r.idCliente === idCliente)?.CLIENTE
          if (recuperado){
            let idCiudad = this.obtenerIdCiudadCliente(recuperado)
            if(!(guia.idCiudadOrigen >0)){
              if(idCiudadOrigenPredeterminada){
                idCiudad = idCiudadOrigenPredeterminada
              }
            }

            setState({
              ...guia,
              CLIENTE_REMITENTE: recuperado,
              idRemitente: recuperado.id,
              direccionRemitente: recuperado.direccion,
              telefonoRemitente: recuperado.direccion,
              idCiudadOrigen: idCiudad
            })
          }
        }
      }
      EstablecerClienteDestinatario( cliente: CLIENTE, guia: logistica_GUIA_PROFORMALocal, setState: (props:logistica_GUIA_PROFORMALocal) => void){
        const idCiudad = this.obtenerIdCiudadCliente(cliente)
        setState({
          ...guia,
          CLIENTE_DESTINATARIO: cliente,
          idDestinatario: cliente.id,
          telefonoDestinatario: cliente.telefono,
          direccionDestinatario: cliente.direccion,
          idCiudadDestino: idCiudad
        })
      }
      EstablecerDireccionProforma(establecimiento:CLIENTE_DIRECCION_PROFORMA, guia: logistica_GUIA_PROFORMALocal, setState: (props:logistica_GUIA_PROFORMALocal) => void){
        setState({
          ...guia,
          idClienteDireccionProforma: establecimiento.id,
          direccionDestinatario: establecimiento.direccion,
          idCiudadDestino: establecimiento.idCiudad
        })
        }
        public handleRowContenido(campo: "cantidad"|"precio"|"descripcion"|"bultos"|"detalles", value: string, index: number,  guia: logistica_GUIA_PROFORMALocal, setState: (props:logistica_GUIA_PROFORMALocal) => void , contenidoList?: logistica_CONTENIDO[]){
          const copyRowsContenido = guia.rowsContenidoParaCrear
          switch(campo){

            case "descripcion":
              const idContenido = Number(value)
              if(idContenido){this._AgregarContenido(idContenido, index, guia, setState, contenidoList)}
              break;
            case "precio":
            case "cantidad":
              if(value === ""){value = "0"}
              if(numerosNaturales(value)){
                const _valor = new BigDecimal(value)
                copyRowsContenido[index][campo] = _valor
                this.CalcularYActualizarRowsContenido(copyRowsContenido, guia, setState)
              }
              break;
            case "bultos":
              if(value === ""){value = "0"}
              if(numerosNaturales(value)){
                copyRowsContenido[index].bultos = Number(value)
                this.CalcularYActualizarRowsContenido(copyRowsContenido, guia, setState)
              }
              break;
            case "detalles":
              copyRowsContenido[index][campo] = value
              if(value.length<=200){
                this.CalcularYActualizarRowsContenido(copyRowsContenido, guia, setState)
              }
              break;
          }
        }
        private _AgregarContenido(idContenido: number, index: number, guia: logistica_GUIA_PROFORMALocal, setState: (props:logistica_GUIA_PROFORMALocal) => void, contenidoList?: logistica_CONTENIDO[]){
          if(contenidoList && contenidoList.length){
            const contenido = contenidoList.find(el => el.id === idContenido)
            const row = new RowContenidoviewModel(contenido)
            const copyRowsContenido = guia.rowsContenidoParaCrear
            copyRowsContenido[index] = row
            setState({
              ...guia,
              rowsContenidoParaCrear: copyRowsContenido
            })
          }
        }
        public AgregarSeguro(seguroItem: logistica_CONTENIDO,  guia: logistica_GUIA_PROFORMALocal, setState: (props:logistica_GUIA_PROFORMALocal) => void,  rangosSeguroPorDefecto: logistica_RANGO_SEGURO[]){
          let porcentajeAUtilizar = new BigDecimal()
            const row = new RowContenidoviewModel(seguroItem)
            row.seguro = true
            row.cantidad = new BigDecimal(1)
            if(guia.valorDeclarado){
              const rsCliente = guia.CLIENTE_REMITENTE?.logistica_RANGO_SEGURO?.find(
                el => new BigDecimal(guia.valorDeclarado).greaterThanOrEqualTo(el.desde) &&
                 new BigDecimal(guia.valorDeclarado).lessThanOrEqualTo(el.hasta) 
              )

              if(rsCliente === undefined){
                const rsPorDefecto = rangosSeguroPorDefecto.find(
                  el => new BigDecimal(guia.valorDeclarado).greaterThanOrEqualTo(el.desde) &&
                   new BigDecimal(guia.valorDeclarado).lessThanOrEqualTo(el.hasta) 
                )
                if(rsPorDefecto){
                  porcentajeAUtilizar = rsPorDefecto.porcentaje
                  porcentajeAUtilizar = new BigDecimal(rsPorDefecto.porcentaje).div(100)
                }else{
                  throw new Error("No se pudo encontar un rango de seguro por defecto")
                }
              }else{
                porcentajeAUtilizar =  new BigDecimal(rsCliente.porcentaje).div(100)
              }
              row.precio = guia.valorDeclarado.times(porcentajeAUtilizar).toDecimalPlaces(2, BigDecimal.ROUND_UP)
              let index = 4
              //Asignamos el seguro al primer row disponible 
              guia.rowsContenidoParaCrear.forEach((el,i) => {
                if(el.seguro === true){
                  index = i
                  return
                }
            })

            const copyRowsContenido = guia.rowsContenidoParaCrear.map((el,i) => {
              if(i === index){
                return row
              }else{
                return el
              }
            } )

            this.CalcularYActualizarRowsContenido(copyRowsContenido, guia, setState)
          return porcentajeAUtilizar.times(100).toFixed(2)
        }
      }
    
        
    BuscarContenido(dispatch: (Details: any) => any, guia: logistica_GUIA_PROFORMALocal){
        if( guia.idCiudadDestino >0 && guia.idCiudadOrigen>0 && guia.idRemitente){
            dispatch(getProductosDisponibles(guia.idRemitente, guia.idCiudadOrigen, guia.idCiudadDestino))    
        }
    }

   
    public BorrarRowContenido(index: number, guia: logistica_GUIA_PROFORMALocal, setState: (props:logistica_GUIA_PROFORMALocal) => void){
      const copyRowsContenido = guia.rowsContenidoParaCrear
      copyRowsContenido[index] = new RowContenidoviewModel()
      this.CalcularYActualizarRowsContenido(copyRowsContenido, guia, setState)
    }

    CalcularYActualizarRowsContenido(copyRowsContenido: RowContenidoviewModel[], guia: logistica_GUIA_PROFORMALocal, setState: (props:logistica_GUIA_PROFORMALocal) => void ){
        for(let row of copyRowsContenido){
            row.subtotal = row.precio.times(row.cantidad).toDecimalPlaces(2, BigDecimal.ROUND_UP)
            if(row.TIPO_IVA?.descripcion === "Base IVA" && row.TIPO_IVA.porcentaje){
                row.BaseIva = row.subtotal
                const porCientoIva = new BigDecimal(100).div(row.TIPO_IVA.porcentaje)
                row.iva = row.subtotal.times(porCientoIva).toDecimalPlaces(2, BigDecimal.ROUND_UP)
            }else{
                row.BaseCero = row.subtotal
                row.iva = new BigDecimal(0)
            }
            row.total = row.subtotal.plus(row.iva)
        }

        const __baseIva = copyRowsContenido.reduce((acum, elemento) => {
          return acum.plus(elemento.BaseIva);
        }, new BigDecimal(0))

        const __baseCero = copyRowsContenido.reduce((acum, elemento) => {
          return acum.plus(elemento.BaseCero);
        }, new BigDecimal(0))

        const __iva = copyRowsContenido.reduce((acum, elemento) => {
          return acum.plus(elemento.iva);
        }, new BigDecimal(0))

        const __total = copyRowsContenido.reduce((acum, elemento) => {
          return acum.plus(elemento.total);
        }, new BigDecimal(0))

        setState({
          ...guia,
          rowsContenidoParaCrear: copyRowsContenido,
          total : __total,
          iva: __iva,
          baseIva: __baseIva,
          baseCero: __baseCero
        })
    }
    private obtenerIdCiudadCliente(cliente:CLIENTE) {
       //actualmente el TypeORM me trae el nomre idCiudad en vez del que está en la base de datos ciudad
       let idCiudad: number = 0
       if(cliente.ciudad){
         idCiudad = cliente.ciudad
       }else{
         idCiudad = (cliente as any).idCiudad??0
       }
       return idCiudad
    }

    /**
     * Valida que el formato de los documentos relacionados sea correcto, puede ser 001-001-999 o 123545
     * o una lista de estos separados por comas. Ejemplos válidos:
     * - 999-999-999
     * - 999999999
     * - 001-002-123,001-002-124
     * - 123456789,987654321
     * - 123456789,001-002-123
     * @param doc
     * @private
     */
    private validarDocumentosRelacionados(doc: string): boolean {
        if(doc.trim().length === 0)
            return true

        const regex = /^(?:\d{3}-\d{3}-\d+|\d+)(?:,(?:\d{3}-\d{3}-\d+|\d+))*$/
        return regex.test(doc);
    }
}


